import { Button, Stack, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { Item } from 'typings'
import { Tag, TagsListTruncate } from '../../../Tag'
import { messages } from './messages'
import { styles } from './styles'

const STACK_WIDTH = 343 // Width of Stack parent from TagsListTruncate
export const MAX_SELLERS_DISPLAY = 15

type Props = {
  sellers: Item[]
  onClick: () => void
}

export function OptInView(props: Props) {
  const { sellers, onClick } = props

  return (
    <Stack space="$space-2">
      <Text tone="secondary">
        <FormattedMessage {...messages.view.label} />
      </Text>
      <TagsListTruncate
        content={sellers.map(({ name }) => name)}
        maxWidth={STACK_WIDTH}
        showEllipsis={false}
        lines={9}
      >
        {sellers.slice(0, MAX_SELLERS_DISPLAY).map(({ name, id }, index) => (
          <TagsListTruncate.Atom key={index}>
            <Tag className={styles.tagContent}>{name || id}</Tag>
          </TagsListTruncate.Atom>
        ))}
      </TagsListTruncate>
      <Button variant="neutralTertiary" onClick={onClick}>
        <FormattedMessage {...messages.view.viewAll} />
      </Button>
    </Stack>
  )
}
